import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import AdminSidePage from "../Components/AdminSidePage";
import ProductItem from "../Components/ProductItemAdmin";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from "chart.js";
import { Bar, Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

let labels = ["January", "February", "March", "April", "May", "June", "July"];

const DashBoard = () => {
    return <AdminSidePage children={<Content />} />;
};

const Content = () => {
    const [mens, setmens] = useState([]);
    const [women, setwomens] = useState([]);

    const dataPie = {
        labels: ["Men", "Women", "Total"],
        datasets: [
            {
                label: "Category Products",
                data: [mens.length, women.length, mens.length + women.length],
                backgroundColor: ["rgba(255, 99, 132, 0.2)", "rgba(54, 162, 235, 0.2)", "rgba(94, 162, 25, 0.2)"],
                borderColor: ["rgba(255, 99, 132, 1)"],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: "Chart.js Bar Chart",
            },
        },
    };

    async function getMenData() {
        try {
            let data = await axios.get(`${process.env.REACT_APP_BACKEND_API}/men`, {
                params: {
                    limit: 100,
                },
                method: "no-cors",
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: process.env.REACT_APP_TOKEN,
                },
            });
            setmens(data.data);
        } catch (error) {
            console.log("error in fetching the data");
        }
    }
    let parentArr = [];
    async function getWomenData() {
        try {
            let data = await axios.get(`${process.env.REACT_APP_BACKEND_API}/men`, {
                params: {
                    limit: 100,
                },
                method: "no-cors",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "application/json",
                    Authorization: process.env.REACT_APP_TOKEN,
                },
            });
            setwomens(data.data);
        } catch (error) {
            console.log("error in fetching the data");
        }
    }
    if (mens.length && women.length) {
        let menobj = {},
            womenobj = {};
        for (let i = 0; i < mens.length; i++) {
            let val = mens[i].brand;
            menobj[val] = menobj[val] ? menobj[val] + 1 : 1;
        }
        for (let i = 0; i < women.length; i++) {
            let val = women[i].brand;
            womenobj[val] = womenobj[val] ? womenobj[val] + 1 : 1;
        }
        parentArr = [];
        for (let key in menobj) {
            let val1 = menobj[key] ? menobj[key] : 0;
            let val2 = womenobj[key] ? womenobj[key] : 0;
            parentArr.push([key, val1, val2]);
        }
        for (let key in womenobj) {
            let val1 = menobj[key] ? menobj[key] : 0;
            let val2 = womenobj[key] ? womenobj[key] : 0;
            if (val1 == 0) parentArr.push([key, val1, val2]);
        }
    }

    let data = {
        labels,
        datasets: [
            {
                label: "Mens",
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: "rgba(53, 162, 235, 0.5)",
            },
            {
                label: "Womens",
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
        ],
    };

    useEffect(() => {
        getMenData();
        getWomenData();
    }, []);
    data.labels = parentArr.filter((el) => {
        return el[0];
    });
    return (
        <Box h="100vh">
            <Heading>DashBoard</Heading>
            <Flex mt="40px" direction={{ base: "column", xl: "row" }} justifyContent={{ base: "center", xl: "space-around" }}>
                <Box overflow={{ sm: "auto" }} w={{ md: "750px" }}>
                    <Bar options={options} data={data} />
                    <Text fontWeight={"bold"}>Distribution of Items Among Various Brands</Text>
                </Box>
                <Flex direction={"column"} justifyContent={{ base: "center", xl: "none" }} mt={{ base: "50px", xl: "0px" }} alignItems="space-between" w={{ base: "100%", xl: "270px" }} mb={{ base: "30px" }}>
                    <Pie data={dataPie} />
                    <Text fontWeight={"bold"} mt="40px">
                        Distribution of Items Among Mens and Womens
                    </Text>
                </Flex>
            </Flex>
        </Box>
    );
};

export default DashBoard;
